import { createAction, props } from "@ngrx/store";
import { IHierarchy } from "@skills-app/models/hierarchy";
import IOrgNode from "@skills-app/models/orgNode";
import { ICapability } from "@skills-app/models/capability";
import {
  IThingSpaceGraph,
  ThingSpaceType,
  ISkillGroupPopularityModel,
} from "@skills-app/models/thingspaceGraph";

const prefix = "[Capabilities Viz API]";

export const requestCapabilityHierarchy = createAction(
  `${prefix} Get CapabilityHierarchy`,
);

export const loadCapabilityHierarchySuccess = createAction(
  `${prefix} Load CapabilityHierarchy Success`,
  props<{ capabilityhierarchy: IHierarchy[] }>(),
);

export const loadCapabilityHierarchyFailure = createAction(
  `${prefix} Load CapabilityHierarchy Failure`,
);

export const requestOrgHierarchy = createAction(
  `${prefix} Get OrgHierarchy`,
  props<{ organisation: IOrgNode[] }>(),
);

export const loadSquadHierarchySuccess = createAction(
  `${prefix} Load SquadHierarchy Success`,
  props<{ squadHierarchy: IHierarchy[] }>(),
);

export const requestCapabilitySkillsList = createAction(
  `${prefix} Get CapabilitySkillsList`,
);

export const loadCapabilitySkillsListSuccess = createAction(
  `${prefix} Load CapabilitySkillsList Success`,
  props<{ capabilityskillslist: unknown }>(),
);

export const requestCapabilityByType = createAction(
  `${prefix} Get Capability By Type`,
  props<{ thingSpaceType: ThingSpaceType }>(),
);

export const loadCapabilityByTypeSuccess = createAction(
  `${prefix} Load Capability By Type Success`,
  props<{ capability: ICapability }>(),
);

export const loadCapabilityByTypeFailure = createAction(
  `${prefix} Load Capability By Type Failure`,
);

export const requestCapabilityDraftByType = createAction(
  `${prefix} Get Capability Draft By Type`,
  props<{ thingSpaceType: ThingSpaceType }>(),
);

export const loadCapabilityDraftByTypeSuccess = createAction(
  `${prefix} Load Capability Draft By Type Success`,
  props<{ draft: IThingSpaceGraph }>(),
);

export const loadCapabilityDraftByTypeFailure = createAction(
  `${prefix} Load Capability Draft By Type Failure`,
);

export const requestCapabilitySkillPopularities = createAction(
  `${prefix} Get Capability Skill Popularities`,
);

export const loadCapabilitySkillPopularitiesSuccess = createAction(
  `${prefix} Load Capability Skill Popularities Success`,
  props<{ skillPopularities: ISkillGroupPopularityModel }>(),
);

export const loadCapabilitySkillPopularitiesFailure = createAction(
  `${prefix} Load Capability Skill Popularities Failure`,
);

export const clearCapabilityDraft = createAction(
  `${prefix} Clear Capability Draft`,
);

export const clearCapabilityMeta = createAction(
  `${prefix} Clear Capability Meta`,
);

export const clearCapabilitySkillPopularities = createAction(
  `${prefix} Clear Capability Skill Popularities`,
);
